<template>
<div >
    <v-toolbar flat color="white">
        <v-btn v-if="canManagePromotions" color="primary" dark class="mb-2" @click="addItem()" round >ADD PROMOTION</v-btn>
        <v-spacer></v-spacer>
        <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>    
    </v-toolbar>

     <!-- Add new item modal -->
    <v-dialog persistent v-model="dialog" max-width="750px">
        <v-card>
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >{{editedItem.type}} PROMOTION</h1>
        </v-toolbar>
          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field class="mx-1"
                    v-model="editedItem.name"
                    label="*Name"
                  ></v-text-field>
                </v-flex>
                      <v-flex xs12 sm6 md6>
                    <v-text-field class="mx-1"
                    v-model="editedItem.code"
                    label="*Code"
                  ></v-text-field>
                  </v-flex>
                  </v-flex>
                  <v-flex xs12 sm6 md6 >
<v-menu :close-on-content-click="false">
                <v-text-field
                  :value="this.editedItem.validFrom"
                  slot="activator"
                  label="*Valid From"
                  prepend-icon="date_range"
                ></v-text-field>
                <v-date-picker v-model="editedItem.validFrom"></v-date-picker>
              </v-menu>
            </v-flex>
              <v-flex xs12 sm6 md6 >
<v-menu :close-on-content-click="false">
                <v-text-field
                  :value="this.editedItem.validTo"
                  slot="activator"
                  label="*Valid To"
                  prepend-icon="date_range"
                ></v-text-field>
                <v-date-picker v-model="editedItem.validTo"></v-date-picker>
              </v-menu>
              </v-flex>
 <v-flex xs12>
                    <v-textarea
                    v-model="editedItem.description"
                    label="Description"
                  ></v-textarea>
                  </v-flex>
               </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-layout justify-center>
            <v-btn round color="primary" @click="close">Cancel</v-btn>
            <v-btn round v-if="editedItem.name&&editedItem.code&&editedItem.validFrom&&editedItem.validTo&&
            editedItem.type=='ADD'" color="primary" @click="saveNew()">Save</v-btn>
         <v-btn round v-else-if="editedItem.name&&editedItem.code&&editedItem.validFrom&&editedItem.validTo&&
         editedItem.type=='EDIT'" color="primary" @click="save()">Save</v-btn>
</v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
      
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :search="search"
      :pagination.sync="pagination"
      :loading="isloading"
      :items="promotions"
      :rows-per-page-items="[10, 25, 50, 100]"
      item-key="name"
      align-center
    >
      <template v-slot:items="props" >
        <td class="justify-center">
            <v-icon v-if="canManagePromotions" small @click="editItem(props.item)">edit</v-icon>
            <v-icon v-if="canManagePromotions" small @click="deleteItem(props.item)">delete</v-icon>
          </td>
          <td class="text-xs-center">{{props.item.name}}</td>
                    <td class="text-xs-center">{{props.item.code}}</td>
<td class="text-xs-center">{{formatDate(props.item.validFrom)}}</td>
<td class="text-xs-center">{{formatDate(props.item.validTo)}}</td>
<td class="text-xs-center">{{props.item.organisationName}}</td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>
  </div>
</template>
 
<script>
import Api from "@/services/Api";
import dateformat from "dateformat";

export default {
  data() {
    return {
    isloading:true,
    search: "",
    dialog: false,
    pagination: { },
    headers: [
            {
        text: "Action",
        align: "center"
      },
      {
        text: "Name",
        align: "center",
        value: "name"
      },
       {
        text: "Code",
        align: "center",
        value: "code"
      },
      {
        text: "Valid From",
        align: "center",
        value: "validFrom"
      },
       {
        text: "Valid To",
        align: "center",
        value: "validTo"
      },
      {
        text: "Organisation",
        align: "center",
        value: "organisationName"
      },
    ],
    promotions: [],
    editedItem: {},
  }
  },
  computed: {
    canManagePromotions() {
      return this.$store.state.user && this.$store.state.user.id == 11468
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  async created() {
        this.initialize();
  },
  methods: {
       formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    },
    fetchPromotions() {
        this.isloading =true
      Api()
        .get("/promotions")
        .then(response => {
          this.promotions = response.data;
          this.isloading =false
        });
      
    },
    initialize() {
      this.fetchPromotions();
    },
     addItem() {
      this.editedItem = {}
      this.editedItem.type='ADD'
      this.dialog = true;
    },
    editItem(item) {
      this.editedItem = item
      this.editedItem.type='EDIT'
      this.dialog = true;
    },
      deleteItem(item) {
      confirm("Are you sure you want to delete this item?") &&
      Api().put("/promotion/" + item.id, {
          isActive: false,
          isDeleted: true,
          ids: item.ids
        }).then(response => {
            this.fetchPromotions();
        })
    },
    close() {
      this.dialog = false;
      this.editedItem={}
    },
    save() {
        Api().put("/promotion/" + this.editedItem.id, {
          name: this.editedItem.name,
          code: this.editedItem.code,
           description: this.editedItem.description,
          validFrom: this.editedItem.validFrom,
          validTo: this.editedItem.validTo,
          ids: this.editedItem.ids
        }).then(response => {
            this.dialog=false
            this.editedItem={}
            this.fetchPromotions();
        })
      },
      saveNew() {
        Api().post("/promotion", {
           name: this.editedItem.name,
          code: this.editedItem.code,
           description: this.editedItem.description,
          validFrom: this.editedItem.validFrom,
          validTo: this.editedItem.validTo    
        }).then(response => {
               this.dialog=false
            this.editedItem={}
            this.fetchPromotions();
        })
    }
  
  }
};
</script>